import { observable } from "mobx";

export default class IsdsResponse {
  conceptIdent: string;
}

export class IsdsConceptStatus {
  @observable statusCode: string;
  @observable statusMessage: string;
}
